import axios from 'axios';
import { BEPI_API } from '../../../shared/config/bepiApiPaths';

// Backend resource path is @Path("web/workshop/..."), mounted under servlet /web/*
const BASE_URL = BEPI_API.workshop;

export const WorkshopHomeApi = {
  // Buscar cotações/ordens de serviço para o dashboard
  getDashboardData: () => axios.get(`${BASE_URL}/home/dashboard`),
  
  // Buscar contadores por status
  getStatusCounters: () => axios.get(`${BASE_URL}/home/status-counters`),
  
  // Buscar equipamento por ID
  getEquipmentById: (equipmentId) => axios.get(`${BASE_URL}/equipment/${equipmentId}`),
  
  // Buscar dados filtrados por status
  getDataByStatus: (status) => axios.get(`${BASE_URL}/home/status/${status}`),
  
  // Atualizar dashboard
  refreshDashboard: () => axios.get(`${BASE_URL}/home/refresh`),
  
  // Assumir cotação (Workshop)
  updateEstimateStatus: (id, status) => axios.put(`${BASE_URL}/home/estimates/${id}/status`, { status }),

  assumeQuotation: (payload) => axios.post(`${BASE_URL}/quotations/assume`, payload),

  unassignQuotation: (payload) => axios.post(`${BASE_URL}/quotations/unassign`, payload)
};
